<template>
  <div class="subscription-requested-modal">
    <div class="booking-requested">
      <a
        data-w-id="f76f2f6e-5dc4-cb59-5ccb-0d1dc8d67c05"
        @click="cancel"
        href="#"
        class="link-block-5 w-inline-block"
        ><img
          src="@/assets/timeslot-images/Group-36561.svg"
          loading="lazy"
          alt=""
      /></a>
      <div class="div-block-52">
        <h1 class="modal-heading">Subscription requested!</h1>
      </div>
      <p class="paragraph-7">
        We sent a subscription request to
        <strong>{{ singleProfessional.customerName }}</strong
        >. If they accept, you will receive a notification
      </p>
      <div class="div-block-85-copy">
        <div class="div-block-86">
          <img
            :src="
              singleProfessional.customerDisplayPicture ||
                require('@/assets/timeslot-images/profileImg.svg')
            "
            loading="lazy"
            width="136"
            alt=""
            class="sub-image"
          /><img
            src="@/assets/timeslot-images/checkmark.svg"
            loading="lazy"
            alt=""
            class="image-18"
          />
        </div>
        <div class="text-block-71">
          Consultation with
          <a href="#" class="link-11">{{ singleProfessional.customerName }}</a>
        </div>
        <div class="div-block-87">
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-69">
              Every {{ days[0] }}<span v-if="days.length > 1">,</span
              >{{ days[1] }}<span v-if="days.length > 1">,</span>{{ days[2] }}
            </div>
          </div>
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/clock1.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-70">
              {{ selectedSubSlot.availableTimeStartTime.slice(0, 5)
              }}{{ amPm(selectedSubSlot.availableTimeStartTime) }}
              -
              {{ selectedSubSlot.availableTimeEndTime.slice(0, 5)
              }}{{ amPm(selectedSubSlot.availableTimeEndTime) }} ({{
                customerInfo.customerTimezone
              }})
            </div>
          </div>
        </div>
      </div>
      <div @click="subscriptions" class="button-15 w-button">
        Check booking status
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "SubscriptionRequestedModal",
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      selectedSubSlot: state => state.availability.selectedSubSlot,
      profSubscriptions: state => state.professional.profSubscriptions,
      customerInfo: state => state.customer.customerInfo
    })
  },
  props: {
    cancel: Function,
    days: Array,
    subscriptions: Function
  },
  methods: {
    shortTimezone(value) {
      let timeStrings = value.split(" ");
      let newList = timeStrings.map(item => item[0]).join("");
      return newList;
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "pm";
      } else {
        return "am";
      }
    }
  }
};
</script>

<style scoped>
.sub-image {
  border-radius: 50%;
  width: 150px;
  height: 150px;
}
</style>
